export const settings: Pickadate.DateOptions = {
  monthsFull: [ 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre' ],
  monthsShort: [ 'Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec' ],
  weekdaysFull: [ 'Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi' ],
  weekdaysShort: [ 'Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam' ],
  today: 'Aujourd\'hui',
  clear: 'Effacer',
  close: 'Fermer',
  firstDay: 1,
  format: 'dd mmmm yyyy',
  formatSubmit: 'yyyy/mm/dd',
  labelMonthNext:"Mois suivant",
  labelMonthPrev:"Mois précédent",
  labelMonthSelect:"Sélectionner un mois",
  labelYearSelect:"Sélectionner une année",
};
